import * as React from 'react';
import { insertCSSIntoDom } from 'shared/utils';
import AnimatableDiv from './AnimatableDiv';
import { mouseEventProps } from './mouseEventProps';
import { joinClass, applyAttributeStyles } from './symbolUtils';
const attributeStyleMap = {
    controlsPosition: {
        'top right': {
            right: 0,
            top: 0,
        },
        'bottom right': {
            right: 0,
            bottom: 0,
        },
        'bottom left': {
            left: 0,
            bottom: 0,
        },
        'top left': {
            left: 0,
            top: 0,
        },
    },
};
export const Video = ({ conditionalState, hoverAnimation, inEditor, innerRef, symbol, timelineRefId, }) => {
    const { clickClass, mouseEventStyles, onClick } = mouseEventProps(symbol, inEditor, hoverAnimation);
    const { attributes, position, styles } = conditionalState;
    const attributeStyles = applyAttributeStyles(Object.assign({ controlsPosition: 'bottom left' }, attributes), attributeStyleMap);
    const { prePlayImage, postCompleteImage, controlsColor = '#ffffff', } = attributes;
    const videoCover = prePlayImage || postCompleteImage;
    const className = joinClass(symbol.id, conditionalState.id, clickClass);
    return (React.createElement(AnimatableDiv, { className: className, hoverAnimation: hoverAnimation, id: timelineRefId, innerRef: innerRef, onClick: onClick, position: position, style: Object.assign(Object.assign(Object.assign({}, mouseEventStyles), styles), { overflow: 'hidden' }), inEditor: inEditor },
        React.createElement("video", { id: `${symbol.id}-videoContent`, className: "adpt-video-dummy" }),
        React.createElement("div", { id: `${symbol.id}-video`, className: "adpt-video-ad" }),
        React.createElement("div", { id: `${symbol.id}-cover`, className: "adpt-cover", style: {
                backgroundImage: `url(${videoCover})`,
            } },
            React.createElement("svg", { className: "adpt-cover-icon", viewBox: "0 0 24 24" },
                React.createElement("path", { fill: controlsColor, fillOpacity: "0.5", d: PlayIconPath })),
            React.createElement("div", { className: "adpt-video-controls", style: attributeStyles },
                React.createElement("svg", { className: "adpt-play", viewBox: "0 0 24 24" },
                    React.createElement("path", { fill: controlsColor, d: PlayIconPath })),
                React.createElement("svg", { className: "adpt-pause", viewBox: "0 0 24 24" },
                    React.createElement("path", { fill: controlsColor, d: PauseIconPath })),
                React.createElement("svg", { className: "adpt-replay", viewBox: "0 0 24 24" },
                    React.createElement("path", { fill: controlsColor, d: ReplayIconPath })),
                React.createElement("svg", { className: "adpt-mute", viewBox: "0 0 24 24" },
                    React.createElement("path", { fill: controlsColor, d: MuteIconPath })),
                React.createElement("svg", { className: "adpt-unmute", viewBox: "0 0 24 24" },
                    React.createElement("path", { fill: controlsColor, d: UnMuteIconPath }))))));
};
export default Video;
// DO NOT USE STYLED-COMPONENT HERE
// Note: These `pointer-events` defined below are crucial for click-through & controls
const videoCSS = `
.adpt-video-dummy {
    pointer-events: none;
}
.adpt-video-ad, .adpt-cover-icon {
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
}
.adpt-cover {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    user-select: none;
}
.adpt-cover-icon {
    cursor: pointer;
    width: 50%;
    height: 50%;
    transition: all 0.25s ease-out;
}
.adpt-cover-icon:hover {
    width: 55%;
    height: 55%;
}
.adpt-video-controls {
    position: absolute;
    display: flex;
    align-items: center;
    padding: 0.25em;
    height: 15%;
    min-height: 30px;
    max-height: 45px;
    box-sizing: border-box;
    transition: bottom 0.15s ease-out;
}
.adpt-video-controls svg {
    pointer-events: auto;
    display: none;
    cursor: pointer;
    margin-right: 0.25em;
    width: auto;
    height: 100%;
    filter: drop-shadow( 1px 1px 1px rgba(0, 0, 0, 0.2));
}
.adpt-video-controls:hover {
    opacity: 1 !important;
}
`;
insertCSSIntoDom(videoCSS, 'video-css');
const PlayIconPath = 'M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M10,16.5L16,12L10,7.5V16.5Z';
const PauseIconPath = 'M15,16H13V8H15M11,16H9V8H11M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z';
const ReplayIconPath = 'M12,5V1L7,6L12,11V7A6,6 0 0,1 18,13A6,6 0 0,1 12,19A6,6 0 0,1 6,13H4A8,8 0 0,0 12,21A8,8 0 0,0 20,13A8,8 0 0,0 12,5Z';
const MuteIconPath = 'M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.84 14,18.7V20.77C18,19.86 21,16.28 21,12C21,7.72 18,4.14 14,3.23M16.5,12C16.5,10.23 15.5,8.71 14,7.97V16C15.5,15.29 16.5,13.76 16.5,12M3,9V15H7L12,20V4L7,9H3Z';
const UnMuteIconPath = 'M12,4L9.91,6.09L12,8.18M4.27,3L3,4.27L7.73,9H3V15H7L12,20V13.27L16.25,17.53C15.58,18.04 14.83,18.46 14,18.7V20.77C15.38,20.45 16.63,19.82 17.68,18.96L19.73,21L21,19.73L12,10.73M19,12C19,12.94 18.8,13.82 18.46,14.64L19.97,16.15C20.62,14.91 21,13.5 21,12C21,7.72 18,4.14 14,3.23V5.29C16.89,6.15 19,8.83 19,12M16.5,12C16.5,10.23 15.5,8.71 14,7.97V10.18L16.45,12.63C16.5,12.43 16.5,12.21 16.5,12Z';
